export const environment = {
    production: true,
    baseUrl: 'https://d119ghktibckmr.cloudfront.net',
    authToken: 'dmlkZW9ib21iOjdVVVhrdXpmRFpqZQ==',
    s3Url: 'https://dnt03h2nq12z4.cloudfront.net',
    analyticsURL: 'https://4tfmixjnm2.execute-api.us-east-1.amazonaws.com/production',
};
